import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  const whatsappNumber = "+237682329126";
  const message = encodeURIComponent("Bonjour, je vous contacte via Roomia.net pour plus d'informations sur vos logements.");

  return (
    <a
      href={`https://wa.me/${whatsappNumber.replace('+', '')}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
      data-testid="whatsapp-float-btn"
      aria-label="Contact via WhatsApp"
    >
      <MessageCircle className="h-6 w-6" />
    </a>
  );
};

export default WhatsAppButton;
